import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox, Form, Input, message } from "antd";
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import { getBrandId, getLanguage } from "../selectors/global";
import PropTypes from "prop-types";
import { subscribeToNewsletter } from "../actions/userProfileAction";
import { userActions } from "../actions/authenticationActions";
import { tokenRegistration } from "../selectors/authentication";


const SubscribeNewsletterForm = ({ brandDetails, form, locale, brandId, subscribeToNewsletter },
                                 context) => {
  const [sending, setSending] = useState(false);
  const authToken = useSelector((state) => state.authentication.authToken);
  const loy3Profile = useSelector((state) => state.authentication.loy3ProfileData);
  const registrationInfo = useSelector((state) => state.authentication.registrationInfo);
  const dispatch = useDispatch();

  useEffect(() => {
      if (brandId && authToken) {
        userActions.getRegistrationInfo(locale, brandId, tokenRegistration)(dispatch)
        userActions.loadProfileData(authToken)(dispatch)
      }
    }, [authToken, brandDetails, brandId, dispatch, locale]
  );

  if (!brandDetails) {
    return null;
  }

  const getPayload = (email) => {
    const payload = { email };
    let additionalPayload = {};
    if (loy3Profile && authToken) {
      const country = registrationInfo.countryCodeTo.find((c) => c.countryId === loy3Profile.country);
      additionalPayload = {
        userName: loy3Profile.firstName,
        userSurname: loy3Profile.lastName,
        userLastname: loy3Profile.secondLastName,
        userCountryCode: country.countryCode.toUpperCase(),
        userLanguage: loy3Profile.preferredLanguage,
      };
    }
    return { ...payload, ...additionalPayload };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        if (values.agreement) {
          setSending(true);
          const payload = getPayload(values.email);
          subscribeToNewsletter(payload)
            .then((subscribeResponse) => {
              setSending(false);
              if (subscribeResponse.ok) {
                form.setFieldsValue({ email: '' });
                message.success(context.t('Registration successfully'));
              } else {
                message.warn(context.t('Some error has occurred. Please, try again.'));
              }
            });
        } else {
          message.warn(context.t('Please accept the conditions!'));
        }
      }
    });
  };

  const { getFieldDecorator } = form;
  return (
    <div className="flex flex-col justify-end w-full lg:w-3/5 py-4 border-gray-300">
      <h2 className="text-white text-title mb-2">{context.t('Our newsletter')}</h2>
      <p className="text-base mb-4">
        {context.t('Sign up today and be the first to get notified on new updates.')}
      </p>
      <Form onSubmit={handleSubmit} className="joinus-form">
        <Form.Item>
          {getFieldDecorator("email", {
            rules: [
              {
                type: "email",
                message: context.t("The input is not valid E-mail!"),
              },
              {
                required: true,
                message: context.t("Please input your E-mail!"),
              },
            ],
          })(
            <Input
              placeholder={context.t("Enter your e-mail address")}
              size="large"
              disabled={sending}
            />
          )}
        </Form.Item>
        <button type="submit" className="btn btn-secondary w-full lg:w-1/3 text-center text-base" disabled={sending}>
          {sending ? context.t('Sending') : context.t('Send')}
        </button>
        <Form.Item className="mb-0">
          {getFieldDecorator("agreement", {
            valuePropName: "checked",
            rules: [
              {
                required: true,
                message: context.t("Please accept the conditions!"),
              },
            ],
          })(
            <Checkbox>
              {context.t("I agree to the")}&nbsp;
              <Link to={`/chain-terms-conditions/${locale}`} target="_blank">
                {context.t("conditions")}
              </Link>
            </Checkbox>
          )}
        </Form.Item>
      </Form>
    </div>
  )
};

SubscribeNewsletterForm.propTypes = {
  brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locale: PropTypes.string,
  subscribeToNewsletter: PropTypes.func.isRequired,
  brandDetails: PropTypes.object,
  form: PropTypes.object.isRequired,
};

SubscribeNewsletterForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  brandId: getBrandId(state),
  locale: getLanguage(state),
});

const mapDispatchToProps = (dispatch) => ({
  subscribeToNewsletter: (payload) => subscribeToNewsletter(payload)(dispatch),
});

const WrappedRegistrationForm = Form.create({ name: "SubscribeNewsletterForm" })(SubscribeNewsletterForm);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedRegistrationForm));
